export default {
  namespaced: true,
  state: {
    checkedPools: {},
    selectAllCheckbox: false,
    resultsCheckbox: {}
  },
  mutations: {
    setCheckedPools: (state, payload) => {
      state.checkedPools = payload
    },
    setSelectAllCheckbox: (state, payload) => {
      state.selectAllCheckbox = payload[0]
      // do it by default
      if (payload.length < 2 || !payload[1]) {
        let resultsCheckboxTmp = state.resultsCheckbox
        for (const objectID in resultsCheckboxTmp) {
          resultsCheckboxTmp[objectID] = payload[0]
        }
        state.resultsCheckbox = resultsCheckboxTmp
      }
    },
    setResultsCheckbox: (state, payload) => {
      state.resultsCheckbox = payload
    },
    setResultCheckbox: (state, payload) => {
      state.resultsCheckbox[payload[0]] = payload[1]
    }
  },
  getters: {
    getSelectedCheckbox (state) {
      var selectedCheckbox = []
      for (const objectId in state.resultsCheckbox) {
        if (state.resultsCheckbox[objectId]) {
          selectedCheckbox.push(parseInt(objectId))
        }
      }
      return selectedCheckbox
    }
  }
}
